import Abstract from './class.Abstract';
import Input from './class.Input';
import { qs, qsAll } from '../dom-helpers';

class SingleProduct extends Abstract {
  constructor() {
    super();

    if (!this.isSingle) return;

    this.quantityWrapper = qs('.single-product .one-item__actions');
    this.accordionButtons = qsAll('.single-product .accordion-btn');

    this.init();
  }

  init() {
    this._initQuantityButtons();
    this._initAccordions();

    return this;
  }

  _initQuantityButtons() {
    if (!this.quantityWrapper) return;

    this.quantityWrapper.addEventListener('click', (e) => {
      const node = e.target;

      if (!node.classList.contains('product__quantity-btn')) return;
      e.preventDefault();

      const buttonType = node.classList.contains('product__quantity-btn--plus') ? 'inc' : 'dec';
      const addToCartButton = node.parentElement.nextElementSibling.children[0];
      let newValue = 0;
      let input = null;

      if (buttonType === 'inc') {
        newValue = parseInt(node.previousElementSibling.children[1].value, 10) + 1;
        input = node.previousElementSibling.children[1];
      } else {
        newValue = parseInt(node.nextElementSibling.children[1].value, 10) - 1;
        if (newValue <= 1) newValue = 1;
        input = node.nextElementSibling.children[1];
      }

      input.value = newValue;
      new Input().updateInputWidth(input);

      addToCartButton.dataset.quantity = newValue;
    });
  }

  _initAccordions() {
    if (!this.accordionButtons.length) return;

    this.accordionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const parent = button.parentElement;

        parent.classList.toggle('accordion-container--opened');
        button.classList.toggle('accordion-btn--opened');
      });
    });
  }
}

export default SingleProduct;
